import type { DeviceApproveInput } from '@kassa/shared';

// Cihazlar ekranının saf köməkçiləri (KT-79): təsdiq seçimi və «yoxlanmalı» səbəblərinin insan dilində adları.

/** Seçim dəyəri "cash:<kassa id>" və ya "main:<obyekt id>" → təsdiq sorğusu; boş və ya yanlışdırsa null. */
export function approveInput(choice: string | undefined): DeviceApproveInput | null {
  const m = /^(cash|main):([0-9a-f-]{36})$/i.exec(choice ?? '');
  if (!m) return null;
  return m[1] === 'cash' ? { role: 'cash', registerId: m[2] } : { role: 'main', outletId: m[2] };
}

const REASONS: Record<string, string> = {
  price_changed: 'köhnə qiymət',
  no_price: 'qiymət yoxdur',
  calc_differs: 'hesab fərqi',
  agri_offline: 'k/t malı internetsiz (ƏDV tam məbləğdən — maya ilə yenidən baxın)',
  total_mismatch: 'cəm uyğun deyil',
  payment_mismatch: 'ödəniş cəmə bərabər deyil',
  card_txn_mismatch: 'kart əməliyyatlarının cəmi kart məbləğinə bərabər deyil (əməliyyatlar ayrıca yoxlanmalı siyahıdadır)',
  card_txn_reused: 'kart əməliyyatı artıq başqa sənəddə işlənib',
  card_terminal_unknown: 'kart terminalı bu obyektdə tapılmadı',
  card_without_terminal: 'terminalı olan kassada kart terminalsız yazılıb',
  credit_limit: 'nisyə limiti aşılıb',
  credit_not_allowed: 'kassirin nisyə icazəsi yoxdur',
  discount_not_allowed: 'kassirin endirim icazəsi yoxdur',
  cashier_not_allowed: 'kassirin satış icazəsi yoxdur',
  shift_closed: 'növbə artıq bağlı idi',
  product_inactive: 'mal passivdir',
  payment_method_off: 'bağlı ödəniş növü',
};

/** Səbəb kodları → «köhnə qiymət, hesab fərqi»; naməlum kod olduğu kimi qalır. */
export function reasonText(reasons: string[]): string {
  return reasons.map((r) => REASONS[r] ?? r).join(', ');
}
